import { API_URL } from "../../shared/constants";
import { emptySplitApi } from "../emptySplit-api";

export const fabricApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fabricThresholdGet: builder.query({
      query: () => ({
        url: `/${API_URL.FABRIC}/${API_URL.THRESHOLD}/get`,
        method: "post",
      }),
    }),
    fabricThresholdUpdate: builder.mutation<any, any>({
      query: (data: any) => ({
        url: `/${API_URL.FABRIC}/${API_URL.THRESHOLD}/update`,
        method: "post",
        body: data,
      }),
    }),
    fabricWarningLogList: builder.query<any, any>({
      query: (data: any) => ({
        url: `/${API_URL.FABRIC}/${API_URL.WARNING_LOG}/list`,
        method: "post",
        body: data,
      }),
    }),
    fabricWarningLogExport: builder.mutation<any, any>({
      query: (data: any) => ({
        url: `/${API_URL.FABRIC}/${API_URL.WARNING_LOG}/export`,
        method: "post",
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFabricThresholdGetQuery,
  useFabricThresholdUpdateMutation,
  useFabricWarningLogListQuery,
  useFabricWarningLogExportMutation,
} = fabricApi;
